/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Source_UrlInputs */

const cs_import_source_url = /** @type {(inputs: Import_Source_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkaz na feed`)
};

const en_import_source_url = /** @type {(inputs: Import_Source_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feed link`)
};

/**
* | output |
* | --- |
* | "Feed link" |
*
* @param {Import_Source_UrlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_source_url = /** @type {((inputs?: Import_Source_UrlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Source_UrlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_source_url(inputs)
	return cs_import_source_url(inputs)
});